<template>
    <div>
      <h1>用户协议</h1>
      <p class="content">
{{company}}再次特别提醒您（用户）在注册成为用户之前，请认真阅读本《用户协议》（以下简称“协议”），确保您充分理解本协议中各条款（特别是以粗体标注的内容）。请您审慎阅读并选择接受或不接受本协议。除非您接受本协议所有条款，否则您无权注册、登录或使用本协议所涉服务。您的注册、登录、使用等行为将视为对本协议的接受，并同意接受本协议各项条款的约束。

本协议约定{{company}}与用户之间关于“APP”软件服务（以下简称“服务”）的权利义务。“用户”是指注册、登录、使用本服务的个人。本协议可由{{company}}随时更新，更新后的协议条款一旦公布即代替原来的协议条款，恕不再另行通知。在{{company}}修改协议条款后，如果用户不接受修改后的条款，请立即停止使用{{company}}提供的服务，用户继续使用{{company}}提供的服务将被视为接受修改后的协议

一、“APP”服务相关定义

1、有权机关：指依照法律法规等有权要求查询、冻结或扣划资金等措施的单位，包括但不限于公安机关、检察院、法院、海关、税务机关。

2、功能封禁：指“APP”有权视情况对违规账户进行某项或某几项功能禁止使用。

3、账号冻结：指“APP”有权视情况对违规账户进行一定时间的禁止使用。被冻结账户冻结期间{{webTitle}}币、钻石不能用于消费，收入、魅力值不能提现、兑换等，被冻结账户冻结期间不可登录、使用。

4、设备封禁：指“APP”有权视情况对违规账户所登录的设备进行一定时间的禁止使用。被设备封禁的登录设备在封禁期间不能登录任何账号。

5、永久封号：指“APP”有权视情况对违规账户进行永久禁止使用并删除账号信息不得再次注册。被永久封号账户内的虚拟货币，将视为违规用户违反本协议的违约金向{{company}}公司支付。

二、账号注册

1、用户在使用本服务前需要注册一个“APP”账号。“APP”账号应当使用手机号码绑定注册，请用户使用尚未与“APP”账号绑定的手机号码。以及未被{{company}}根据本协议封禁的手机号码注册“APP”账号。{{company}}可以根据用户需求或产品需求对账号注册和绑定的方式进行更改，而无须事先通知用户。

2、“APP”系基于地理位置的移动直播产品，用户注册时应当授权{{company}}公开及使用其他地理位置信息方可成功注册“APP”账号。故用户完成注册即表明用户同意{{company}}提取、公开及使用用户的地理位置信息。

3、鉴于“APP”账号的绑定注册方式，您同意{{company}}在注册时将自动提取您的手机号码及手机设备识别码等信息用于注册。

4、在用户注册及使用本服务时，{{company}}需要搜集能识别用户身份的个人信息以便{{company}}可以在必要时联系用户，或为用户提供更好的使用体验。{{company}}搜集的信息包括但不限于用户的姓名、性别、出生日期、身份证号、学校情况、公司情况、所属行业、城市、常玩游戏、常去门店、个性签名、会员卡号；{{company}}同意对这些信息的使用将受限于第三条用户个人隐私信息保护的约束。

三、服务内容

1、本服务的具体内容由{{company}}根据实际情况提供，包括但不限于授权用户通过其他账号进行即时通讯、添加好友、加入群组、关注他人、发布动态。{{company}}可以对其提供的服务予以变更，且{{company}}提供的服务内容可能随时变更；用户将会收到{{company}}关于服务变更的通知。

四、用户个人隐私信息保护

1、用户在注册账号或使用本服务的过程中，可能需要填写一些或提交一些必要的信息，如法律法规，规章规范性文件（以下简称“法律法规”）规定的需要填写的身份信息。如用户提交的信息不完整或不符合法律法规的规定，则用户可能无法使用本服务或在使用本服务的过程中收到的限制。

2、个人隐私信息是指涉及用户个人身份或个人隐私的信息，比如，用户真实姓名、身份证、手机号码、手机设备识别码、IP地址、用户聊天记录、会员卡号。非个人隐私信息是指用户对本服务的操作状态以及使用习惯等明确且客观反映在{{company}}服务器端的基本记录信息、个人隐私信息范围外的其他普通信息，以及用户同意公开的上述隐私信息。

3、尊重用户个人隐私信息的私有性是{{company}}的一贯制度，{{company}}将采取技术措施或其他必要措施，确保用户个人隐私信息安全，防止在本服务中收集的用户个人隐私信息泄露、毁损或丢失。在发生前述情形的可能时，将及时采取补救措施。

4、{{company}}未经用户同意不向任何第三方公开、透露用户个人隐私信息。但以下特定情形除非：
 1)、{{company}}根据法律法规规定或有权机关的指示提供用户的个人隐私信息；
 2)、由于用户将其用户密码告知他人或与他人共享注册账号与密码，由此导致的任何个人信息的泄露，或其他非因{{company}}原因导致的个人隐私信息的泄露；
 3)、用户自行向第三方公开其个人隐私信息；
 4)、用户与{{company}}及合作单位之间就用户个人隐私信息的使用公开达成约定，{{company}}此向合作单位公开用户个人隐私信息；
 5)、任何由于黑客攻击、电脑病毒侵入及其他不可抗力事件导致用户个人隐私信息的泄露；

5、用户同意{{company}}可在以下事项中使用用户的个人隐私信息：
 1)、{{company}}向用户及时发送重要通知，如软件更新，本协议条款的变更；
 2)、{{company}}内部进行审计、数据分析和研究等，已改进{{company}}的产品，服务和与用户之间的沟通；
 3)、依本协议约定，{{company}}管理、审核用户信息及进行处理措施；
 4)、适用法律法规规定的其他事项；

除上述事项外，如未取得用户事先同意，{{company}}不会将用户个人隐私信息适用于任何其他用途。

6、{{company}}重视对未成年人个人隐私信息的保护。{{company}}将依赖用户提供的个人信息判断用户是否为未成年人。任何18岁以下的未成年人注册账号或使用本服务应事先取得家长或其法定监护人（以下简称“监护人”）的书面同意。除根据法律法规的规定及有权机关的指示披露外，{{company}}不会使用向任何第三方透露未成年人的聊天记录及其他个人隐私信息。除本协议约定的例外情形外，未经监护人事先同意，{{company}}不会使用向任何第三方透露未成年人的个人隐私信息。

7、用户确认，其地理位置信息为非个人隐私信息，用户成功注册“APP”账号视为确认授权{{company}}提取、公开及使用用户的地理位置信息。用户地理位置信息将作为用户公开资料之一，由{{company}}向其他用户公开。如用户需终止向其他用户公开其地理位置信息，可随时自行设置手机隐私。

8、用户确认，其消费信息、收益获得信息为非个人隐私信息，用户成功注册“APP”账号视为确认授权{{company}}提取、公开及使用用户的消费信息、收益获得信息。用户消费信息、收益获得信息将作为用户公开资料之一，由{{company}}向其他用户公开。

9、为了改善{{company}}的技术和服务，向用户提供更好的服务体验，{{company}}或会自行收集使用或向第三方提供用户的非个人隐私信息。

10、关于账号注销在线提供账号注册相关信息，若账号未进行认证则无法提供注销。

五、内容规范

1、本条所述内容是指用户使用本服务过程中所制作、上载、复制、发布、传播的任何内容，包括但不限于账号头像、名称、个性签名等注册信息及认证资料，或文字，语音，图片、图文等发送、回复消息和相关链接页面，以及其他使用账号或本服务所产生的内容。

2、用户不得利用“APP”账号或本服务制作、上载、复制、发布、传播如下法律、法规和政策禁止的内容：
 1)、反对宪法所确定的基本原则的；
 2)、危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；
 3)、损害国家荣誉和利益的；
 4)、煽动民族仇恨、民族歧视，破坏民族团结的；
 5)、破坏国家宗教政策，宣扬邪教和封建迷信的；
 6)、散布谣言，扰乱社会秩序，破坏社会稳定的；
 7)、散步淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；
 8)、侮辱或者诽谤他人，侵害他人合法权益的；
 9)、含有法律、行政法规禁止的其他内容的信息；

3、用户不得利用“APP”账号或本服务制作、上载、复制、发布、传播下干扰“APP”正常运营，以及侵犯其他用户或第三方合作权益的内容：
 1)、含有任何性暗示的；
2)、含有辱骂、恐吓、威胁内容的；
3)、含有骚扰、垃圾广告、恶意信息、诱骗信息的；
4)、涉及他人隐私、个人信息或资料的；
5)、侵害他人名誉权、肖像权、知识产权、商业秘密等合法权利的；
6)、含有其他干扰本服务正常运营和侵犯其他用户或第三方合法权益内容的信息；

六、使用规则

1、用户在本服务中或通过本服务所传送、发布的任何内容并不反映或代表，也不得被视为反映或代表{{company}}的观点、立场或政策，{{company}}对此不承担任何责任。

2、用户不得利用“APP”账号或本服务进行如下行为：
1)、提交、发布虚假信息、或盗用他人头像或资料，冒充、利用他人名义的；
2)、强制、诱导其他用户关注、点击链接页面或分享信息的；
3)、虚构事实、隐瞒真相以误导、欺骗他人的；
4)、利用技术手段批量建立虚假账号的；
5)、利用“APP”账号或本服务从事任何犯罪活动的；
6)、制作、发布于以上行为相关的方法、工具，或对此类方法、工具进行运营或传播，无论这些行为是否为商业目的；
7)、其他违法法律法规规定、侵犯其他用户合法权益、干扰“APP”正常运营或{{company}}未明示授权的行为；

3、用户须对利用“APP”账号或本服务传送信息的真实性、合法性、无害性、准确性、有效性等全权负责，与用户所传播信息相关的任何法律责任由用户自行承担，与{{company}}无关。如因此给{{company}}或第三方造成损害的，用户应当依法予以赔偿。

4、用户在“APP“的内容消费（内容消费特指：聊天室礼物打赏、动态礼物打赏、消息礼物打赏、属于礼物打赏等）行为，皆完全基于您的自主、自愿行为；内容消费行为一旦发生概不退款；则由用户自行对内容消费负责；{{company}}不承担任何责任。

5、{{company}}提供的服务中可能包括广告，用户同意在使用过程中显示{{company}}和第三方供应商、合作伙伴提供的广告。除法律法规明确规定外，用户应自行对该广告信息进行的交易负责，对用户因依该广发信息进行的交易或前述广告商提供的内容或遭受的损失或损害，{{company}}不承担任何责任。

七、虚拟货币
 1、{{company}}在将“{{webTitle}}”平台发行虚拟货币，即{{webTitle}}币。用户确认，购买的{{webTitle}}币能用于本产品提供的线上线下的订单支付服务、网络表演打赏服务、动态打赏服务、开车业务（不支持网鱼网费充值，网鱼网费充值金额仅限于线下网鱼门店消费，与“{{webTitle}}”APP内{{webTitle}}币并不互通）。任何情况下不得与{{company}}以外的第三方进行购买.如违反前述约定，造成用户或第三方任何损失，{{company}}不负任何责任，且{{company}}有理由怀疑用户的账户或使用情况有作弊或异常状况，{{company}}将拒绝该用户使用账户内{{webTitle}}币进行支付，直至按本协议约定采取相关封禁措施。
1）{{webTitle}}币和人民币的兑换比例依用户购买渠道不同而有所不同的兑换比例，具体比例依以用户购买{{webTitle}}币相关渠道服务页面显示为准。{{company}}有权根据运营情况随时变更上述兑换比例，并将在用户购买{{webTitle}}币的相关服务页面上显示。
 2）用户默认已开通{{webTitle}}币账户，可进行{{webTitle}}币购买（下称“充值”）和消费，用户可在我的-我的钱包中查询到{{webTitle}}币的购买和消费记录。{{webTitle}}币的相关信息将不作为公开信息。
 3）用户可以通过平台提供的{{webTitle}}币充值途径为{{webTitle}}币账户进行充值。用户确认不会以非法方式或使用非平台指定的充值途径进行充值，如用户违规使用非{{company}}认可的购买途径非法购买{{webTitle}}币，则{{company}}不保证购买顺利或正确完成，若因此造成用户权益受损，{{company}}将不会做出任何补偿或赔偿，{{company}}同时保留随时终止用户{{webTitle}}账号资格及使用各项充值/购买服务的权利，并进行相应后续处理。
 4）用户确认在进行充值前已经仔细确认过自己的账号并仔细选择了相关操作选项，若用户自身输入账号错误、操作不当或不了解充值计费方式等因素造成充错账号、购买错误、错选充值种类等情形而损害自身权益的， {{company}}将不会作出任何补偿或赔偿。
 5）用户确认，购买{{webTitle}}币成功后，除法律法规明确规定或本协议另有约定外，{{webTitle}}币在任何情况下不能兑换法定货币，不能转让他人。除法律法规明确规定或本协议另有约定外， {{webTitle}}币购买成功后，{{company}}不予退款。

2、{{company}}在将“{{webTitle}}”平台发行虚拟货币，即钻石。用户确认，购买钻石只能用于本产品提供内容服务。如：网络表演打赏、钻石活动支付等。任何情况下不得与{{company}}以外的第三方进行购买.如违反前述约定，造成用户或第三方任何损失，{{company}}不负任何责任，且{{company}}有理由怀疑用户的钻石账户或使用情况有作弊或异常状况，{{company}}将拒绝该用户使用账户钻石进行支付，直至按本协议约定采取相关封禁措施。
 1）钻石和人民币的兑换比例依用户购买渠道不同而有所不同的兑换比例，具体比例依以用户购买钻石相关渠道服务页面显示为准。{{company}}有权根据运营情况随时变更上述兑换比例，并将在用户购买钻石的相关服务页面上显示。
 2）用户默认已开通钻石账户，可进行钻石购买（下称“充值”）和消费，用户可在我的-我的钱包中查询到钻石的购买和消费记录。钻石的相关信息将不作为公开信息。
 3）用户可以通过平台提供的钻石充值途径为钻石账户进行充值。用户确认不会以非法方式或使用非平台指定的充值途径进行充值，如用户违规使用非{{company}}认可的购买途径非法购买钻石，则{{company}}不保证购买顺利或正确完成，若因此造成用户权益受损，{{company}}将不会做出任何补偿或赔偿，{{company}}同时保留随时终止用户{{webTitle}}账号资格及使用各项充值/购买服务的权利，并进行相应后续处理。
 4）用户确认在进行充值前已经仔细确认过自己的账号并仔细选择了相关操作选项，若用户自身输入账号错误、操作不当或不了解充值计费方式等因素造成充错账号、购买错误、错选充值种类等情形而损害自身权益的， {{company}}将不会作出任何补偿或赔偿。
 5）用户确认，购买钻石成功后，除法律法规明确规定或本协议另有约定外，钻石在任何情况下不能兑换法定货币，不能转让他人。除法律法规明确规定或本协议另有约定外， 钻石购买成功后，{{company}}不予退款。

3、{{webTitle}}币收入
 1）{{webTitle}}币收入是用户在开车业务/动态打赏业务/聊天消息打赏业务收到的打赏后获得的货币；也是用户成为大神，且同意大神协议后，在平台内接单获得的收益。
    用户打赏金额的值扣除30%手续费后，进入{{webTitle}}币收入
    订单金额扣除0手续费后，进入{{webTitle}}币收入
 2）订单收益与人民币兑换比例为1:1，兑换比例将由{{company}}根据运营情况随时进行变更，并将在大神订单收益的相关服务页面上显示。
 3）用户对{{webTitle}}币收入进行提现时由用户注册时签订艺人协议的其中一家企业（见本协议第二条4款）收款且代缴个人所得税后，进入用户银行账户。

4、魅力值收益
 1）魅力值收益指用户在平台通过除订单外但包含且不限聊天室、直播间等所获魅力值收益。
 2）收益的魅力值与人民币兑换比例为1:0.7，其中的0.3为平台的手续费抽成。兑换比例将由{{company}}根据运营情况随时进行变更，并将在用户魅力值收益的的相关服务页面上显示。
 3）用户所获魅力值收益，由用户注册时签订艺人协议的其中一家企业（见本协议第二条4款）收款且代缴个人所得税后，用户获得魅力值提现后的税后酬劳。

5、定价权
用户应遵守“APP”内的定价规则，不得擅自对“APP”内的定价规则进行任何形式的更改，包括但不限于：线上游戏、线上娱乐、文艺生活、心理咨询、外语、线下游戏等模块。用户不得以任何形式绕开“APP”内定价规则进行线上或线下交易，亦不得通过私下交易的方式逃避“APP”内定价规则。

八、账户管理

1、“APP”账户的所有权归{{company}}所有，用户完成申请注册手续后，获得“APP”账号的使用权，该使用权输入初始申请注册人，禁止赠予、借用、租用、转让或售卖。{{company}}因经营需要，有权回收用户的“APP”账户。

2、用户可以更改、删除“APP”账户上的个人资料、注册信息及传送内容等。但需注意，删除有关信息的同时也会删除用户储存在系统中的文字和图片。用户需承担风险。

3、用户有责任妥善保管注册账户信息及账号密码的安全，因用户保管不善可能导致遭受盗号或密码失窃，责任由用户自行承担。用户需要对注册账号以及密码下的行为承担法律责任。用户同意在任何情况下不使用其他用户的账号或密码。在用户怀疑他人使用其账号或密码时，用户同意立即通知{{company}}。

4、用户应遵守本协议的各项条款，正确、适当地使用本服务，如因用户违反本协议中的任何条款，{{company}}在通知用户后有权依据协议中断或终止对违约用户的“APP”账号提供服务。同时，{{company}}保留在任何时候收回“APP”账号的权利。

5、如用户注册“APP”账户后连续24个月不登陆，在通知用户3日后，{{company}}可以收回该账号，以免造成资源浪费，由此造成的不利后果由用户自行承担。

九、数据储存

1、{{company}}不对用户在本服务中相关数据的删除或储存失败负责。

2、{{company}}可以根据实际情况自行决定用户在本服务中数据的最长储存期限，并在服务器上为其分配数据最大的存储空间等。用户根据自己的需要自行备份本服务中的相关数据。

3、如用户停止使用本服务或本服务终止，{{company}}可以从服务器上永久删除用户的数据。本服务停止，终止后，{{company}}没有义务向用户返回任何数据。

十、风险承担

1、用户理解并同意，“APP”仅为用户提供信息分享、传送及获取的平台，用户必须为自己注册账号下的一切行为负责，包括用户所传送的任何内容以及由此产生的任何后果。用户应对“APP”及本服务中的内容自行加以判断，并承担因使用内容而引起的所有风险，包括因对内容的正确性、完整性或实用性的依赖而产生的风险。{{company}}无法且不会对因用户行为而导致的任何损失或损害承担责任。如果用户发现任何人违反本协议约定或以其他不当的方式使用本服务，请立即向{{company}}举报或投诉，{{company}}将依本协议约定进行处理。

2、用户理解并同意，因业务发展需要，{{company}}保留单方面对本服务的全部或部分服务内容变更、暂停、终止或撤销的权利，用户需承担此风险。

十一、知识产权声明

1、除本服务中涉及广告的知识产权由相应广告商享有外，{{company}}在本服务中提供的内容（包括但不限于网页、文字、图片、音频、视频、图表等）的知识产权均归{{company}}所有，但用户在使用本服务前对自己发布的内容已合法取得知识产权的除外。

2、除另有特别声明外，{{company}}提供本服务时所依托软件的著作权、专利权及其他知识产权均归{{company}}所有。

3、{{company}}在本服务中所涉及的图形、文字或其组成，以及其他{{company}}标志及产品、服务名称（以下统称“{{company}}标识”），其著作权或商标权归{{company}}所有。未经{{company}}事先书面同意，用户不得将{{company}}标识以任何方式展示或使用或作其他处理，也不得向他人表明用户有权展示、使用或其他有权处理{{company}}标识的行为。

4、上述及其他任何与{{company}}或相关广告商依法拥有的知识产权均受到法律保护，未经{{company}}或相关广告商书面许可，用户不得以任何形式进行使用或创造相关衍生作品。

十二、法律责任

1、如果{{company}}发现或受到他人举报或投诉用户违反本协议的约定的，{{company}}有权不经通知随时对相关内容，包括但不限于用户资料、聊天记录进行审查、删除。并视情节轻重对违规账号处以包括但不限于警告、功能封禁、账号冻结、设备封禁、功能封禁、永久封号的违规违约处理，且通知用户处理结果。

2、用户理解并同意，{{company}}有权依合理判断对违反有关法律法规或本协议规定的行为进行处罚，对违法违规的任何用户采取适当的法律行动，并依据法律法规保存有关信息向有关部门报告等，用户应承担由此产生的一切法律责任。

3、用户理解并同意，因用户违反本协议约定，导致或产生的任何第三方主张的任何索赔、要求或损失，包括合理的律师费，用户应当赔偿{{company}}与合作公司、关联公司，并使之免收损害。

4、用户理解并同意，因用户违反本协议约定，导致{{company}}对其进行永久封号处理的，用户被永久封号后，账户内的现金余额、钻石余额、魅力值余额将均不得再进行提现。上述现金余额、钻石余额、魅力值余额将视为违规用户向{{company}}支付的违约金，由{{company}}收取并支配。

 5、用户（包括但不限于：注册用户、封号用户及注销用户等）不得恶意抹黑、诋毁{{company}}及相关APP；不得传播损害{{company}}及相关APP的相关言论及不实报道；不得煽动粉丝等网络群体恶意攻击{{company}}及相关APP。任何用户未经{{company}}书面同意，不得在任何新闻媒体、自媒体等平台上发布有关{{company}}及相关APP的言论或接受有关{{company}}及相关APP的采访。若用户违反上述约定，{{company}}有权根据相关法律规定向其追究法律责任以及主张损失赔偿。

十三、不可抗力及其他免责事由

1、用户理解并确认，在使用本服务的过程中，可能会遇到不可抗力等风险因素，使本服务发生中断。不可抗力是指不能预见、不能克服并不能避免且对一方或双方造成重大影响的客观事件，包括但不限于自然灾害如洪水、地震、瘟疫流行和风暴等以及社会事件如战争、动乱、政府行动等。出现上述情况时。{{company}}将努力在第一时间与相关单位配合，及时进行修复，但是由此给用户或第三方造成的损失，{{company}}及合作单位在法律允许的范围内免责。

2、本服务同大多数互联网服务一样，受包括但不限于用户原因、网络服务质量、社会环境等因素的差异影响，可能受到各种安全问题的侵扰，如他人利用用户的资料，造成现实生活中的骚扰；用户下载安装的其它软件或访问的其他网站中含有“特洛伊木马”等病毒，威胁到用户的计算机信息和数据的安全，继而影响本服务的正常使用等等。用户应加强信息安全及使用者资料的保护意识，要注意加强密码保护，以免遭致损失和骚扰。

3、用户理解并确认，本服务存在因不可抗力、计算机病毒或黑客攻击、系统不稳定、用户所在位置、用户关机以及其他任何技术、互联网络、通信线路原因等造成的服务中断或不能满足用户要求的风险，因此导致的用户或第三方任何损失，{{company}}不承担任何责任。

4、用户理解并确认，在使用本服务过程中存在来自任何他人的包括误导性的、欺骗性的、威胁性的、诽谤性的、令人反感的或非法的信息，或侵犯他人权利的匿名或冒名的信息，以及伴随该等信息的行为，因此导致的用户或第三方的任何损失，{{company}}不承担任何责任。

5、用户理解并确认，{{company}}需要定期或不定期地对“APP”平台或相关的设备进行检修或者维护，如因此类情况而造成服务在合理时间内的中断，{{company}}无需为此承担任何责任，但{{company}}应事先进行通告。

6、{{company}}依据法律法规、本协议约定获得处理违法违规或违约内容的权利，该权利不构成{{company}}的义务或承诺，{{company}}不能保证及时发现违法违规或违约行为或进行相应处理。

7、用户理解并确认，对于{{company}}向用户提供的下列产品或者服务的质量缺陷及其引发的任何损失，{{company}}无需承担任何责任：

8、在任何情况下，{{company}}均不对任何间接性、后果性、惩罚性、偶然性、特殊性或刑罚性的损害，包括因用户使用“APP”或本服务而遭受的利润损失，承担责任（即使{{company}}已被告知该等损失的可能性亦然）。尽管本协议中可能含有相悖的规定，{{company}}对用户承担的全部责任，无论因何原因或何种行为方式，始终不超过用户因使用{{company}}提供的服务而支付给{{company}}的费用(如有)。

十四、服务的变更、中断、终止

1、鉴于网络服务的特殊性，用户同意{{company}}有权随时变更、中断或终止部分或全部的服务（包括收费服务）。{{company}}变更、中断或终止的服务，{{company}}应当在变更、中断或终止之前通知用户，并应向受影响的用户提供等值的替代性的服务。

2、如发生下列任何一种情形，{{company}}有权变更、中断或终止向用户提供的免费服务或收费服务，而无需对用户或任何第三方承担任何责任：
1)、根据法律规定用户应提交真实信息，而用户提供的个人资料不真实或与注册时信息不一致又未能提供合理证明；
2)、用户违反相关法律法规或本协议的约定；
3)、按照法律规定或有权机关的要求；
4)、出于安全的原因或其他必要的情形。

十五、其他

1、{{company}}郑重提醒用户注意本协议中免除{{company}}责任和限制用户权利的条款，请用户仔细阅读，自主考虑风险。未成年人应在法定监护人的陪同下阅读本协议。

2、本协议的任何条款无论因何种原因无效或不具可执行性，其余条款仍有效，对双方具有约束力。

十六、特别声明
鉴于：我国《合同法》第39条规定：采用格式条款订立合同的，提供格式条款的一方应当遵循公平原则确定当事人之间的权利和义务，并采取合理的方式提请对方注意免除或者限制其责任的条款，按照对方的要求，对该条款予以说明。
{{company}}在此依法做出特别声明如下：
{{company}}采取合理的方式提请用户注意的义务将通过如下方式实现：在本协议中{{company}}以明确的足以引起用户注意的加重字体、斜体、下划线、颜色标记等合理方式提醒用户注意相关条款(需要强调的是，还包括用户应特别注意任何未明确标记的含有“不承担”、“免责”、“不得”等形式用语的条款)，该等条款的确认将导致用户在特定情况下的被动、不便、损失，请用户在确认同意本协议之前再次阅读上述条款。双方确认上述条款非属于《合同法》第40条规定的“免除其责任、加重对方责任、排除对方主要权利的”的条款，{{company}}尊重用户的权利尤其是诉讼的权利，但作为全球运营的公司，{{company}}在尊重用户诉讼权利的同时建议诉讼管辖地法院为{{company}}所在地法院，而用户选择同意合同并使用服务即视为双方对此约定达成了一致意见。
用户如有任何需要说明条款的要求，请立即停止使用服务，同时立即发送邮件至ashu@wefaceapp.com ，若用户未致电或发送有说明条款要求的邮件至{{company}}而选择同意该协议，则双方在此确认{{company}}已依法履行了根据用户要求对相关条款进行说明的法定义务，{{company}}已给予用户充足的时间与充分的选择权来决定是否缔结本协议。
鉴于{{company}}已依法明确了上述条款、履行了格式条款制订方的义务，用户点击同意或下一步，将被视为且应当被视为用户已经完全注意并同意了本协议所有条款尤其是提醒用户注意的条款的合法性及有效性，用户不应当以{{company}}未对格式条款以合理方式提醒用户注意，或未根据用户要求尽到说明义务为理由而声称或要求法院或其它任何第三方确认相关条款非法或无效。

十八、法律适用与管辖
本协议之效力、解释、变更、执行与争议解决均适用中华人民共和国法律。因本协议产生之争议，均应依照中华人民共和国法律予以处理，并由{{company}}住所地人民法院管辖。
      </p>
    </div>
</template>
<script>
import { webTitle, company } from '../../utils'

export default {
  name: 'server',
  computed: {
    webTitle () {
      return webTitle()
    },
    company () {
      return company()
    }
  }
}
</script>
<style lang="scss" scoped>
.content{
  padding:0 40px 0;
  white-space: pre-wrap;
  text-align: left;
}
</style>
